import React, { useEffect, useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Loaders } from '../../pages/Loaders';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getAllCity, getCateg, getLocations } from '../apifile/ApiFiles';
import { baseUrl } from '../login/baseUrl';
import { toast, ToastContainer } from 'react-toastify';
import { message } from 'antd';
import ListResumePage from '../../pages/list-resume';
import BulkModel from '../candidateProfile/candidate-listProfile/Candidatetable/BulkModel';

function SearchCandidate({ setDataForm }) {
    const [advanceData, setAdvanceData] = useState(null)
    const [dataShowCom, setDataShowCom] = useState(true)
    const [modalShow, setModalShow] = useState(false)
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(10)
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        job_category: '',
        location: '',
        status: '',
        gender: '',
        min_salary: '',
        max_salary: '',
        min_experience: '',
        max_experience: '',
        keyword: '',
        start_date: '',
        end_date: '',
        and_operator: false,


        keywords: '',
        exclusiveKeywords: '',
        itSkills: '',
        experienceFrom: '',
        experienceTo: '',
        currentLocation: '',
        salaryFrom: '',
        salaryTo: '',
        age: '',
        name: '',
        email: '',
        date_of_Birth: '',
        country: '',
        state: '',
        city: '',
        nationality: '',
        gender: '',
        // mobile: '',
        careerLevel: '',
        industry: '',
        functionalArea: '',
        jobExperience: '',
        expectedSalary: '',
        currentSalary: '',
        salaryCurrency: '',
        boolean: false,
    });
    setDataForm(formData)

    const [load, setload] = useState(false)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };


    const handleBooleanToggle = () => {
        setFormData((prev) => ({
            ...prev,
            and_operator: !prev.and_operator,
        }));
    };

    const constructQueryParams = (data) => {
        const params = new URLSearchParams();

        // Map only non-empty fields to the query params
        Object.entries(data).forEach(([key, value]) => {
            if (value) {
                params.append(key, value);
                // if (key === 'experienceFrom' && data.experienceTo) {
                //     params.append('jobExperience', `${data.experienceFrom}-${data.experienceTo}`);
                // } else if (key === 'salaryFrom' && data.salaryTo) {
                //     params.append('expectedSalary', `${data.salaryFrom}-${data.salaryTo}`);
                // } else if (!['experienceTo', 'salaryTo'].includes(key)) {
                //     params.append(key, value);
                // }
            }
        });

        return params.toString();
    };

    const navigate = useNavigate()
    const notify = (updateMassage) => toast(updateMassage);
    const handleSubmit = async (page) => {
        setload(true)
        // e.preventDefault();
        // // const baseUrl = 'https://abarishr.hennainternational.in/api/apply/job/';
        // const baseUrl = 'https://abarishr.hennainternational.in/api/apply/job/'

        // const queryParams = constructQueryParams(formData);
        // const url = `${baseUrl}?${queryParams}`;
        // setTimeout(() => {
        //     navigate(`/admin/list-resume/${queryParams}`)
        //     setload(false)
        // }, 1000);
        // return
        try {
            const res = await axios.get(
                `${baseUrl}/candidate/filter?name=${formData?.name ? formData.name : ''}&mobile=${formData?.mobile ? formData.mobile : ''}&email=${formData?.email ? formData.email : ''}&job_category=${formData?.job_category ? formData.job_category : ''}&location=${formData?.location ? formData.location : ''}&status=${formData?.status ? formData.status : ''}&keyword=${formData?.keyword}&min_experience=${formData?.min_experience}&max_experience=${formData?.max_experience}&min_salary=${formData?.min_salary}&max_salary=${formData?.max_salary}&gender=${formData?.gender}&start_date=${formData?.start_date}&end_date=${formData?.end_date}&and_operator=${formData?.and_operator}&page=${page}&count=${count}`,
                {
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
                    },
                }
            );

            if (res?.data?.error == false && res?.data?.data?.length > 0) {
                console.log(res?.data);
                // notify(res?.data?.message)
                setAdvanceData(res?.data)
                setDataShowCom(false)
                // setTimeout(() => {
                //     // navigate(`/admin/list-resume`)
                //     navigate('/admin/list-resume', {
                //         state: { advanceData: res?.data?.data },
                //         total: res?.data?.totalCandidate,
                //         page,
                //         count
                //     });
                // }, 1000);
                setload(false)
            } else {
                setload(false)
                alert("No Data Found")
                setAdvanceData(res?.data)
            }
        } catch (error) {
            alert(error?.message)
        }
        setload(false)

        return

        // try {
        //     const response = await fetch(url);
        //     if (!response.ok) {
        //         throw new Error('Network response was not ok');
        //     }
        //     const data = await response.json();
        //     console.log('Response:', data);
        // } catch (error) {
        //     console.error('Fetch error:', error);
        // }
        // setload(false)
    };
    const [genders, setGenders] = useState(null)
    const [locationdata, setLocationdata] = useState()
    const [jobCategory, setJobCategory] = useState(null)
    const [cityData, setCitydata] = useState(null)


    const getGender = async (id) => {
        try {
            const gender = await axios.get(
                `https://abarishr.hennainternational.in/api/gender/public`
            );
            setGenders(gender?.data);
            const reslocation = await getLocations()
            setLocationdata(reslocation);
            const rescategory = await getCateg()
            setJobCategory(rescategory?.data)
            // const res = await getAllCity()
            // setCitydata(res?.data);
            // const skill = await getSkill()
            // setSkilData(skill)
        } catch (error) {

        }
    };

    useEffect(() => {
        getGender()
    }, []);



    const onChangeVal = (e) => {
        // console.log(e - 1);

        setPage(e - 1)
        handleSubmit(e - 1)
    };

    const [selectedIds, setSelectedIds] = useState([]);
    console.log(selectedIds);

    const emailSendModal = () => {
        setModalShow(true)

    }



    return (
        // {loader && <Loaders/>}
        <>
            {dataShowCom ?
                <div className="container">
                    {load && <Loaders />}
                    <h4>Candidate Advance Search</h4>
                    <Form >
                        <Row className="mb-3">
                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="keywords">
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Form.Label>Keywords</Form.Label>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <Form.Check
                                                type="switch"
                                                id="boolean-switch"
                                                checked={formData.and_operator}
                                                onChange={handleBooleanToggle}
                                                style={{ marginRight: "5px" }}
                                            />
                                            <span>{formData.and_operator ? "Boolean on" : "Boolean off"}</span>
                                        </div>
                                    </div>
                                    <Form.Control
                                        type="text"
                                        name="keyword"
                                        placeholder="Enter keywords like skills, designation and company"
                                        value={formData.keyword}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="gender">
                                    <Form.Label>Job Category</Form.Label>
                                    <select className="form-select" id="lang" value={formData?.job_category} name="job_category" onChange={handleChange}>
                                        <option value>Select Job Category</option>
                                        {jobCategory &&
                                            jobCategory?.map((item) => {
                                                return <option key={item._id} value={item._id}>{item.category_name}</option>;
                                            })}
                                    </select>

                                </Form.Group>
                            </Col>

                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="experienceFrom">
                                    <Form.Label>Experience (From)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder='From'
                                        name="min_experience"
                                        value={formData.min_experience}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="experienceTo">
                                    <Form.Label>Experience (To)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder='To'
                                        name="max_experience"
                                        value={formData.max_experience}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>

                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="salaryFrom">
                                    <Form.Label>Min Salary </Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder='Min Salary'
                                        name="min_salary"
                                        value={formData.min_salary}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="salaryTo">
                                    <Form.Label>Max Salary </Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder='max_salary'
                                        name="max_salary"
                                        value={formData.max_salary}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="currentLocation">
                                    <Form.Label>Location / City</Form.Label>
                                    <select
                                        className="form-select"
                                        onChange={handleChange}
                                        name="location"
                                        value={formData?.location}
                                    >
                                        <option>Select Location / City</option>
                                        {locationdata &&
                                            locationdata?.data?.map((item) => {
                                                return (
                                                    <option value={item._id}>{item.location_name}</option>
                                                );
                                            })}
                                    </select>
                                    {/* <Form.Control
                                type="text"
                                placeholder='Current Location'
                                name="currentLocation"
                                value={formData.currentLocation}
                                onChange={handleChange}
                            /> */}
                                </Form.Group>
                            </Col>
                            {/* <Col lg={6} className="mb-3">
                        <Form.Group controlId="date_of_Birth">
                            <Form.Label>Date of Birth</Form.Label>
                            <Form.Control
                                type="date"
                                name="date_of_Birth"
                                value={formData.date_of_Birth}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col> */}
                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="date_of_Birth">
                                    <Form.Label>Start Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="start_date"
                                        value={formData.start_date}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="date_of_Birth">
                                    <Form.Label>End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="end_date"
                                        value={formData.end_date}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>

                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="exclusiveKeywords">
                                    <Form.Label>Mobile </Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder='Mobile Number'
                                        name="mobile"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Group controlId="gender">
                                    <Form.Label>Gender</Form.Label>
                                    <select className="form-select" id="lang" value={formData?.gender} name="gender" onChange={handleChange}>
                                        <option value>Select Gender</option>
                                        {genders &&
                                            genders?.map((item) => {
                                                return <option key={item._id} value={item._id}>{item.gender}</option>;
                                            })}
                                    </select>
                                    {/* <Form.Control
                                as="select"
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                            >
                                <option value="">Select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </Form.Control> */}
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="itSkills">
                            <Form.Label>IT Skills</Form.Label>
                            <Form.Control
                                type="text"
                                name="itSkills"
                                value={formData.itSkills}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>


                </Row> */}

                        {/* <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="currentLocation">
                            <Form.Label>Current Location</Form.Label>
                            <Form.Control
                                type="text"
                                name="currentLocation"
                                value={formData.currentLocation}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>


                </Row> */}

                        {/* <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="firstname">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="lastname">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="lastname"
                                value={formData.lastname}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                </Row> */}



                        {/* <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="date_of_Birth">
                            <Form.Label>Date of Birth</Form.Label>
                            <Form.Control
                                type="date"
                                name="date_of_Birth"
                                value={formData.date_of_Birth}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="country">
                            <Form.Label>Country</Form.Label>
                            <Form.Control
                                type="text"
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="state">
                            <Form.Label>State</Form.Label>
                            <Form.Control
                                type="text"
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>

                </Row> */}

                        {/* <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="city">
                            <Form.Label>City</Form.Label>
                            <Form.Control
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="nationality">
                            <Form.Label>Nationality</Form.Label>
                            <Form.Control
                                type="text"
                                name="nationality"
                                value={formData.nationality}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="functionalArea">
                            <Form.Label>Functional Area</Form.Label>
                            <Form.Control
                                type="text"
                                name="functionalArea"
                                value={formData.functionalArea}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                </Row> */}
                        {/* <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="gender">
                            <Form.Label>Gender</Form.Label>
                            <Form.Control
                                as="select"
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                            >
                                <option value="">Select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>

                    <Col>
                        <Form.Group controlId="careerLevel">
                            <Form.Label>Career Level</Form.Label>
                            <Form.Control
                                type="text"
                                name="careerLevel"
                                value={formData.careerLevel}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="industry">
                            <Form.Label>Industry</Form.Label>
                            <Form.Control
                                type="text"
                                name="industry"
                                value={formData.industry}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>

                </Row> */}

                        {/* <Row className="mb-3">

                    <Col>
                        <Form.Group controlId="jobExperience">
                            <Form.Label>Job Experience</Form.Label>
                            <Form.Control
                                type="text"
                                name="jobExperience"
                                value={formData.jobExperience}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="expectedSalary">
                            <Form.Label>Expected Salary</Form.Label>
                            <Form.Control
                                type="text"
                                name="expectedSalary"
                                value={formData.expectedSalary}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="currentSalary">
                            <Form.Label>Current Salary</Form.Label>
                            <Form.Control
                                type="text"
                                name="currentSalary"
                                value={formData.currentSalary}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="salaryCurrency">
                            <Form.Label>Salary Currency</Form.Label>
                            <Form.Control
                                type="text"
                                name="salaryCurrency"
                                value={formData.salaryCurrency}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                </Row> */}

                        <Col className='text-center'>
                            <Button variant="primary" type="button" style={{ width: '300px', height: '50px', borderRadius: '30px', fontWeight: 'bolder', fontSize: '20px', padding: '0' }} onClick={() => handleSubmit(0)}>
                                Search
                            </Button>
                        </Col>
                    </Form>
                    <ToastContainer />
                </div> :
                <ListResumePage advanceData={advanceData} onChangeVal={onChangeVal} setDataShowCom={setDataShowCom} setFormData={setFormData} emailSendModal={emailSendModal} setSelectedIds={setSelectedIds} selectedIds={selectedIds} />

            }
            <BulkModel
                show={modalShow}
                onHide={() => setModalShow(false)}
                selectedIds={selectedIds}
            />
        </>
    );
}

export default SearchCandidate;
